"use client";

import { createContext, useEffect, useState } from "react";

export const DeviceContext = createContext({ isMobile: false });

export function DeviceProvider({ children, ssrMobile }) {
  const [isMobile, setIsMobile] = useState(ssrMobile);
  const [hasHydrated, setHasHydrated] = useState(false);

  useEffect(() => {
    setHasHydrated(true);
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Use SSR-detected value until hydration finishes
  const effectiveIsMobile = hasHydrated ? isMobile : ssrMobile;

  return (
    <DeviceContext.Provider value={{ isMobile: effectiveIsMobile }}>
      {children}
    </DeviceContext.Provider>
  );
}
